import LaunchIcon from '@mui/icons-material/Launch'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import { EntityKpi } from '@components/EntityKpi'
import { MyListButton } from '@components/MyListButton'
import { formatDateTime } from '@util/date-util'

import type { Activiteit } from '../../../entity/activiteiten/types/Activiteit'
import { Due } from '../../../theme/components/Due'
import { Label } from '../../../theme/components/Label'
import { MultilineTypography } from '../../../theme/components/MultilineTypography'
import { StyledIconLink } from '../../../theme/components/StyledIconLink'

const getEntityLabel = (type: string, projecttype?: string) => {
  return (
    projecttype ||
    {
      project: 'Project',
      projectdossier: 'Projectdossier',
    }[type]
  )
}

interface Props {
  activiteit: Activiteit
}

export const ActiviteitenTableRow = ({ activiteit }: Props) => {
  const {
    _id,
    type,
    text,
    changed,
    assignedTo,
    dueDate,
    entity: { id: entityId, type: entityType, projecttype, gebiedscodeLabel },
    searchValues,
    myList,
    kpi,
    labels,
  } = activiteit
  const { organisatie, date: created } = activiteit.created

  return (
    <TableRow key={_id}>
      <TableCell>
        <EntityKpi kpi={kpi} />
      </TableCell>
      <TableCell>{type}</TableCell>
      <TableCell>
        <MultilineTypography text={text} />
      </TableCell>
      <TableCell>
        <Due dueDate={dueDate as string | undefined} />
      </TableCell>
      <TableCell>{formatDateTime(created)}</TableCell>
      <TableCell>{organisatie}</TableCell>
      <TableCell>{assignedTo && assignedTo.join(', ')}</TableCell>
      <TableCell>{formatDateTime(changed)}</TableCell>
      <TableCell>
        {getEntityLabel(entityType, projecttype)} <span>{entityId}</span>
      </TableCell>
      <TableCell>
        <MultilineTypography text={searchValues?.adres} />
      </TableCell>
      <TableCell>
        {gebiedscodeLabel}
        <br />
        {labels && labels.map((l) => <Label text={l} key={l} small={true} />)}
      </TableCell>
      <TableCell>
        <MyListButton
          type="aansluiting"
          disabled={true}
          active={myList}
          aanvraagID={''}
        />

        <StyledIconLink
          icon={<LaunchIcon />}
          title={`Navigeer naar ${entityType} ${entityId}`}
          href={`/aansluiting/${entityType}/${entityId}`}
        />
      </TableCell>
    </TableRow>
  )
}
